import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import TableList from '@/components/TableList/index.vue';
import ListCard from './listCard.vue';
import ConfirmBtn from '@/components/ConfirmBtn/index.vue';
import { deleteFont, downloadFont, cropFont } from '@/api/common/font';
import { downloadWithIframe } from '@/common/download';

export default {
  components: {
    TableList: TableList,
    ListCard: ListCard,
    ConfirmBtn: ConfirmBtn
  },

  computed: {
    isCheckbox: function isCheckbox() {
      if (this.selectConfig.type) {
        return this.selectConfig.type === 'checkbox';
      }
      // 兼容旧调用，没有type的场景
      return true;
    },
    isRadio: function isRadio() {
      return this.selectConfig.type === 'radio';
    },
    isCardType: function isCardType() {
      return this.type === 'card';
    },
    isTableType: function isTableType() {
      return this.type === 'table';
    },
    isFontType: function isFontType() {
      return this.type === 'font';
    },
    tableColumnConfig: function tableColumnConfig() {
      if (this.isFontType) {
        return [{
          label: '字体',
          prop: 'name'
        }, {
          label: '字体名字(languages.json中加字体时用到的值)',
          prop: 'postscript_name'
        }, {
          label: '语言',
          prop: 'languages'
        }, {
          label: '标签',
          prop: 'tags_id',
          params: {
            innerHTML: function innerHTML(_ref) {
              var row = _ref.row;

              return '' + (row.tags && row.tags.length ? row.tags.map(function (item) {
                return item.name;
              }).join() : '');
            }
          }
        }, {
          slot: 'font-cover-cell',
          prop: 'postscript_name'
        }, {
          slot: 'action-cell',
          prop: 'action-cell'
        }];
      }
      return [{
        label: '选择',
        prop: 'selection',
        type: 'selection',
        visible: this.canSelect
      }, {
        label: 'ID',
        prop: 'id'
      }, {
        label: '文案内容',
        prop: 'message',
        params: {
          maxLength: 50
        }
      }, {
        label: '使用频率',
        prop: 'use_times'
      }, {
        label: '更新时间',
        prop: 'updated_time',
        type: 'time',
        params: {
          format: '{y}-{m}-{d} {h}:{i}:{s}'
        }
      }, {
        slot: 'action-cell',
        prop: 'action-cell'
      }];
    },
    cellClass: function cellClass() {
      if (this.isRadio) {
        return 'hide-check-all';
      }
      return '';
    }
  },

  data: function data() {
    return {
      listModel: [],
      cropDataTime: {},
      cropLoading: {}
    };
  },


  props: {
    type: {
      type: String,
      default: 'card'
    },
    canSelect: Boolean,
    selectConfig: {
      type: Object,
      default: function _default() {
        return {
          type: 'checkbox',
          defaultList: [], // 默认选中值
          handleChange: function handleChange() {}
        };
      }
    },
    list: Array,
    loading: Boolean,
    handleUpdate: Function,
    handleDelete: Function
  },

  methods: {
    isDisabled: function isDisabled(id) {
      return (this.selectConfig.defaultList || []).indexOf(Number(id)) !== -1;
    },
    isChecked: function isChecked(id) {
      return (this.selectConfig.defaultList || []).indexOf(Number(id)) !== -1;
    },
    handleUpdateFont: function handleUpdateFont(item) {
      this.$emit('updateFont', item);
    },
    handleChange: function handleChange(data) {
      var _this = this;

      var dataId = void 0,
          dataItem = void 0;
      if (this.type === 'card') {
        dataId = data;
        dataItem = this.list.filter(function (e) {
          if (_.isArray(data)) {
            return data.indexOf(e.id) !== -1;
          }
          return e.id === data;
        });
        if (this.isRadio) {
          dataItem = dataItem[0] || {};
        }
      } else if (this.type === 'table') {
        dataItem = data;
        if (this.isCheckbox) {
          dataId = [];
          if (data && data.length) {
            dataId = data.map(function (e) {
              return Number(e.id);
            });
          }
        } else if (this.isRadio) {
          dataId = '';
          dataItem = {};
          if (data.length) {
            data.forEach(function (row, index) {
              if (index === data.length - 1) return;
              _this.$refs.table.toggleRowSelection(row, false);
            });
            // 避免toggleRowSelection触发的handleChange事件重复触发
            if (data.length === 2) return;
            dataItem = data[0];
            dataId = dataItem.id;
          }
        }
      }
      this.selectConfig.handleChange(dataId, dataItem);
    },
    handleDeleteFont: function handleDeleteFont(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return deleteFont({
                  id: item.id
                });

              case 3:
                _this2.$emit('reload');
                _this2.$message({
                  message: '删除成功',
                  type: 'success'
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    },
    handleCropTest: function handleCropTest(item) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var time;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.cropLoading = _extends({}, _this3.cropLoading, _defineProperty({}, item.id, true));
                time = new Date().getTime();
                _context2.next = 5;
                return cropFont({
                  font: item.postscript_name,
                  text: 'abcdefghijklmnopqrstuvwxyz' + new Date().getTime() // 固定测试裁剪文本
                });

              case 5:
                _this3.cropDataTime = _extends({}, _this3.cropDataTime, _defineProperty({}, item.id, new Date().getTime() - time));
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 11:
                _this3.cropLoading = _extends({}, _this3.cropLoading, _defineProperty({}, item.id, false));

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 8]]);
      }))();
    },
    handledownload: function handledownload(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return downloadFont({
                  id: item.id
                });

              case 3:
                res = _context3.sent;

                if (_.get(res, 'data.code') === 0) {
                  downloadWithIframe(_.get(res, 'data.data.url'), '', true);
                  _this4.$message({
                    message: '下载成功',
                    type: 'success'
                  });
                }
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 7]]);
      }))();
    },
    handleSelectionChange: function handleSelectionChange() {}
  }
};